import { action, computed, observable } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';

class LoyaltySubmitAReceiptController extends ViewController {
    private loyaltyRepository: LoyaltyRepository;

    @observable isViewDetailsModalOpen: boolean = false;

    constructor(loyaltyRepository: LoyaltyRepository) {
        super();
        this.loyaltyRepository = loyaltyRepository;
    }

    @action
    public toggleViewDetailsModal = () => {
        this.isViewDetailsModalOpen = !this.isViewDetailsModalOpen;
    };

    @action
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @computed
    public get data() {
        return {
            loyaltyInfo: this.loyaltyRepository?.loyaltyInfo
        };
    }
}

export default LoyaltySubmitAReceiptController;
